var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.19 5.74536H25.2824L18.5265 13.4669L26.4743 23.9742H20.2513L15.3771 17.6016L9.80007 23.9742H6.70585L13.9319 15.7151L6.30762 5.74536H12.6886L17.0944 11.5702L22.19 5.74536ZM21.1047 22.1232H22.8182L11.7576 7.49907H9.91879L21.1047 22.1232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.106fe9f904b7bdbae7d496a935881dd4.svg";
export { ForwardRef as ReactComponent };